import { Link } from "react-router-dom";

const Footer: React.FC = () => (
  <footer className="mt-16 border-t border-primary-100/70">
    <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-3 px-4 py-7 text-sm text-ink/50 sm:flex-row sm:px-6">
      <span className="flex items-center gap-2">
        <img src="/logo.svg" alt="" className="h-5 w-5" />
        <span>© {new Date().getFullYear()} Kinoes</span>
      </span>
      <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1">
        <Link to="/privacy" className="transition-colors hover:text-primary-600">
          Privacy
        </Link>
        <Link to="/sms-policy" className="transition-colors hover:text-primary-600">
          SMS Policy
        </Link>
        <Link to="/terms" className="transition-colors hover:text-primary-600">
          Terms
        </Link>
      </nav>
    </div>
  </footer>
);

export default Footer;
